/* NDX self-registration front end (N Tour / N Dealer Roadshow).
 *
 * Renders the dealer landing state and the registration form from
 * /apps/check-in/ndx/info and submits to /apps/check-in/ndx/register.
 * The server re-validates everything; this layer only guides the participant.
 *
 * All customer facing copy comes from the theme locale files and is injected
 * by snippets/ndx-strings.liquid. Nothing is hard coded here.
 */
(function () {
  'use strict';

  var COPY = readStrings();

  function readStrings() {
    var node = document.querySelector('[data-ndx-strings]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function t(path, fallback) {
    var parts = path.split('.');
    var value = COPY;
    for (var index = 0; index < parts.length; index += 1) {
      if (!value || typeof value !== 'object') return fallback || '';
      value = value[parts[index]];
    }
    return typeof value === 'string' && value ? value : fallback || '';
  }

  function param(name) {
    return new URLSearchParams(window.location.search).get(name) || '';
  }

  function el(tag, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    return node;
  }

  function setNotice(root, message, isSuccess) {
    var notice = root.querySelector('[data-ndx-notice]');
    if (!notice) return;
    if (!message) {
      notice.hidden = true;
      notice.textContent = '';
      return;
    }
    notice.className = 'ndx__notice' + (isSuccess ? ' ndx__notice--success' : '');
    notice.textContent = message;
    notice.hidden = false;
  }

  function fetchInfo(dealer) {
    var url = '/apps/check-in/ndx/info?dealer=' + encodeURIComponent(dealer) + '&locale=' + encodeURIComponent(COPY.locale || 'de');
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('info request failed');
      return response.json();
    });
  }

  function uniqueDates(slots) {
    var dates = [];
    (slots || []).forEach(function (slot) {
      if (slot.date && dates.indexOf(slot.date) === -1) dates.push(slot.date);
    });
    return dates;
  }

  /* ------------------------------ landing page ---------------------------- */

  function initLanding(root) {
    // A dealer page always shows its own dealer; the query parameter is only a
    // fallback for a landing section without an assigned dealer.
    var dealer = root.dataset.ndxDealer || param('dealer') || '';
    var body = root.querySelector('[data-ndx-body]');
    var cta = root.querySelector('[data-ndx-cta]');
    var registrationUrl = root.dataset.ndxRegistrationUrl || '/pages/n-anmeldung';

    if (!dealer) {
      body.textContent = t('landing.unavailable');
      return;
    }

    fetchInfo(dealer)
      .then(function (info) {
        body.textContent = '';

        var name = el('p', 'ndx-dealer__name');
        name.textContent = info.dealer.name;
        body.appendChild(name);

        if (info.program !== 'n-tour' && info.dealer.address) {
          var address = el('p', 'ndx-dealer__address');
          address.textContent = info.dealer.address;
          body.appendChild(address);
        }

        var dates = uniqueDates(info.slots);
        if (dates.length) {
          var dateLine = el('p', 'ndx-dealer__dates');
          dateLine.textContent = dates.join(t('landing.dates_separator', ', '));
          body.appendChild(dateLine);
        }

        if (cta) {
          cta.hidden = false;
          if (info.soldOut) {
            cta.textContent = t('landing.cta_sold_out');
            cta.classList.add('ndx-dealer__cta--disabled');
            cta.setAttribute('aria-disabled', 'true');
            cta.removeAttribute('href');
          } else {
            cta.textContent = t('landing.cta');
            cta.classList.remove('ndx-dealer__cta--disabled');
            cta.removeAttribute('aria-disabled');
            cta.href = registrationUrl + '?dealer=' + encodeURIComponent(info.dealer.handle);
          }
        }
      })
      .catch(function () {
        body.textContent = t('landing.unavailable');
        if (cta) cta.hidden = true;
      });
  }

  /* --------------------------- registration form -------------------------- */

  function renderMeta(info) {
    var meta = el('div', 'ndx__meta');
    var list = el('dl');
    var rows = [[t('form.dealer_label'), info.dealer.name]];
    if (info.program === 'n-tour') {
      rows.push([t('form.meeting_point_label'), t('form.meeting_point_address'), true]);
    } else if (info.dealer.address) {
      rows.push([t('form.address_label'), info.dealer.address]);
    }
    if (!info.slotSelection && info.slots.length === 1) {
      rows.push([t('form.date_label'), info.slots[0].date || '']);
      var time = info.slots[0].time;
      rows.push([t('form.time_label'), time ? time + t('form.time_suffix', '') : '']);
    }
    var rendered = 0;
    rows.forEach(function (row) {
      if (!row[1]) return;
      var dt = el('dt');
      dt.textContent = row[0];
      var dd = el('dd');
      dd.textContent = row[1];
      if (row[2]) dd.classList.add('ndx__meta-meeting-point');
      list.appendChild(dt);
      list.appendChild(dd);
      rendered += 1;
    });
    if (!rendered) return null;
    meta.appendChild(list);
    return meta;
  }

  function renderField(field) {
    var type = String(field.fieldType || '').toLowerCase();
    if (!field.fieldKey || type === 'info' || type === 'heading') {
      if (!field.helperHtml) return null;
      // Footnotes are info rows too, but set smaller like in the brief.
      var isFootnote = /footnote/.test(field.fieldKey || '');
      var heading = el('div', isFootnote ? 'ndx__footnote' : 'ndx__section-heading');
      heading.innerHTML = field.helperHtml;
      return heading;
    }

    var wrapper = el('div', 'ndx__field');
    var id = 'ndx-' + field.fieldKey;

    if (field.fieldType === 'checkbox') {
      wrapper.className = 'ndx__field ndx__field--checkbox';
      var box = el('input');
      box.type = 'checkbox';
      box.id = id;
      box.name = field.fieldKey;
      box.value = 'true';
      if (field.isRequired) box.required = true;
      wrapper.appendChild(box);
      var copy = el('label', 'ndx__consent');
      copy.htmlFor = id;
      copy.innerHTML = field.helperHtml || (field.label || '');
      if (field.isRequired) {
        var star = el('span', 'ndx__required');
        star.textContent = ' *';
        // Keep the marker on the same line as the consent text.
        var paragraphs = copy.querySelectorAll('p');
        (paragraphs.length ? paragraphs[paragraphs.length - 1] : copy).appendChild(star);
      }
      wrapper.appendChild(copy);
      return wrapper;
    }

    var label = el('label');
    label.htmlFor = id;
    label.textContent = field.label || field.fieldKey;
    if (field.isRequired) {
      var mark = el('span', 'ndx__required');
      mark.textContent = ' *';
      label.appendChild(mark);
    }
    wrapper.appendChild(label);

    if (type === 'select') {
      var select = el('select');
      select.id = id;
      select.name = field.fieldKey;
      if (field.isRequired) select.required = true;
      var empty = el('option');
      empty.value = '';
      empty.textContent = field.placeholder || t('form.slot_placeholder');
      select.appendChild(empty);
      (field.options || []).forEach(function (option) {
        var item = el('option');
        item.value = option.value;
        item.textContent = option.label || option.value;
        select.appendChild(item);
      });
      if (field.fieldKey === 'general-country') {
        // Reuse the established check-in country combobox interaction contract.
        // Donor: sections/checkin.liquid; only field bindings and styling differ.
        const fieldId = id;
        const fieldWrapper = wrapper;
        const required = Boolean(field.isRequired);
        const normalizedSelectOptions = field.options || [];
        const translations = {
          countrySearch: field.placeholder || field.label,
          selectPlaceholder: field.placeholder || field.label
        };
        let countrySearchInput;
        const countryListId = `${fieldId}-country-options`;
        const countrySearchWrapper = document.createElement('div');
        countrySearchWrapper.className = 'checkin-country-search';
        countrySearchInput = document.createElement('input');
        countrySearchInput.type = 'search';
        countrySearchInput.className = 'field__input field__input--country-search';
        countrySearchInput.id = `${fieldId}-country-search`;
        countrySearchInput.setAttribute('autocomplete', 'off');
        countrySearchInput.setAttribute('spellcheck', 'false');
        countrySearchInput.setAttribute('inputmode', 'search');
        countrySearchInput.placeholder = translations.countrySearch;
        countrySearchInput.setAttribute('aria-label', translations.countrySearch);
        countrySearchInput.setAttribute('role', 'combobox');
        countrySearchInput.setAttribute('aria-autocomplete', 'list');
        countrySearchInput.setAttribute('aria-expanded', 'false');
        countrySearchInput.setAttribute('aria-controls', countryListId);
        if (required) {
            countrySearchInput.required = true;
            countrySearchInput.setAttribute('aria-required', 'true');
        }
        const countryList = document.createElement('ul');
        countryList.id = countryListId;
        countryList.className = 'checkin-country-search__list';
        countryList.setAttribute('role', 'listbox');
        countryList.hidden = true;
        countrySearchWrapper.appendChild(countrySearchInput);
        countrySearchWrapper.appendChild(countryList);
        fieldWrapper.appendChild(countrySearchWrapper);

        select.classList.add('field__input--country-native');
        select.required = false;
        select.removeAttribute('aria-required');
        select.tabIndex = -1;
        select.setAttribute('aria-hidden', 'true');

        let filteredCountryOptions = [];
        let activeCountryIndex = -1;
        const countryValidityMessage =
            translations.selectPlaceholder || translations.countrySearch;
        const normalizeCountrySearch = (value) =>
            String(value || '')
                .trim()
                .toLowerCase();
        const closeCountryDropdown = () => {
            countryList.hidden = true;
            countrySearchInput.setAttribute('aria-expanded', 'false');
            activeCountryIndex = -1;
            countrySearchInput.removeAttribute('aria-activedescendant');
        };
        const updateCountryValidity = () => {
            const hasSelection = Boolean(select.value);
            const hasText = Boolean(countrySearchInput.value.trim());
            if (hasSelection || (!required && !hasText)) {
                countrySearchInput.setCustomValidity('');
                return;
            }
            countrySearchInput.setCustomValidity(countryValidityMessage);
        };
        const clearCountrySelection = () => {
            select.value = '';
            countrySearchInput.removeAttribute('data-selected-label');
            countrySearchInput.removeAttribute('data-selected-value');
        };
        const setActiveCountryOption = (nextIndex) => {
            const optionElements = countryList.querySelectorAll(
                '.checkin-country-search__option'
            );
            optionElements.forEach((optionEl, optionIndex) => {
                const isActive = optionIndex === nextIndex;
                optionEl.classList.toggle('is-active', isActive);
                optionEl.setAttribute('aria-selected', isActive ? 'true' : 'false');
                if (isActive) {
                    countrySearchInput.setAttribute('aria-activedescendant', optionEl.id);
                    optionEl.scrollIntoView({ block: 'nearest' });
                }
            });
            if (nextIndex < 0 || nextIndex >= optionElements.length) {
                countrySearchInput.removeAttribute('aria-activedescendant');
            }
            activeCountryIndex = nextIndex;
        };
        const commitCountrySelection = (option) => {
            if (!option) return;
            select.value = option.value;
            countrySearchInput.value = option.label;
            countrySearchInput.dataset.selectedLabel = option.label;
            countrySearchInput.dataset.selectedValue = option.value;
            countrySearchInput.setCustomValidity('');
            closeCountryDropdown();
        };
        const filterCountryOptions = (rawValue) => {
            const query = normalizeCountrySearch(rawValue);
            if (!query) return [...normalizedSelectOptions];
            return normalizedSelectOptions.filter((option) => {
                const label = option.label.toLowerCase();
                const value = option.value.toLowerCase();
                return label.includes(query) || value.includes(query);
            });
        };
        const renderCountryOptions = () => {
            countryList.innerHTML = '';
            if (filteredCountryOptions.length === 0) {
                closeCountryDropdown();
                return;
            }
            filteredCountryOptions.forEach((option, optionIndex) => {
                const optionEl = document.createElement('li');
                optionEl.id = `${countryListId}-option-${optionIndex + 1}`;
                optionEl.className = 'checkin-country-search__option';
                optionEl.setAttribute('role', 'option');
                optionEl.setAttribute('aria-selected', 'false');
                optionEl.textContent = option.label;
                optionEl.addEventListener('mousedown', (event) => {
                    event.preventDefault();
                });
                optionEl.addEventListener('click', () => {
                    commitCountrySelection(option);
                });
                countryList.appendChild(optionEl);
            });
            countryList.hidden = false;
            countrySearchInput.setAttribute('aria-expanded', 'true');
            setActiveCountryOption(filteredCountryOptions.length > 0 ? 0 : -1);
        };

        countrySearchInput.addEventListener('focus', () => {
            filteredCountryOptions = filterCountryOptions(countrySearchInput.value);
            renderCountryOptions();
        });
        countrySearchInput.addEventListener('input', () => {
            const selectedLabel = countrySearchInput.dataset.selectedLabel || '';
            if (
                normalizeCountrySearch(countrySearchInput.value) !==
                normalizeCountrySearch(selectedLabel)
            ) {
                clearCountrySelection();
            }
            filteredCountryOptions = filterCountryOptions(countrySearchInput.value);
            renderCountryOptions();
            updateCountryValidity();
        });
        countrySearchInput.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                if (countryList.hidden) {
                    filteredCountryOptions = filterCountryOptions(
                        countrySearchInput.value
                    );
                    renderCountryOptions();
                    return;
                }
                const nextIndex = Math.min(
                    activeCountryIndex + 1,
                    filteredCountryOptions.length - 1
                );
                setActiveCountryOption(nextIndex);
                return;
            }
            if (event.key === 'ArrowUp') {
                event.preventDefault();
                if (countryList.hidden) {
                    filteredCountryOptions = filterCountryOptions(
                        countrySearchInput.value
                    );
                    renderCountryOptions();
                    return;
                }
                const nextIndex = Math.max(activeCountryIndex - 1, 0);
                setActiveCountryOption(nextIndex);
                return;
            }
            if (event.key === 'Enter' && !countryList.hidden) {
                event.preventDefault();
                const option = filteredCountryOptions[activeCountryIndex];
                if (option) {
                    commitCountrySelection(option);
                }
                updateCountryValidity();
                return;
            }
            if (event.key === 'Escape') {
                closeCountryDropdown();
                return;
            }
        });
        countrySearchInput.addEventListener('blur', () => {
            window.setTimeout(() => {
                closeCountryDropdown();
                updateCountryValidity();
            }, 120);
        });
        countrySearchInput.addEventListener('invalid', () => {
            updateCountryValidity();
        });
        select.addEventListener('change', () => {
            const option = select.options[select.selectedIndex];
            countrySearchInput.value =
                option && option.value ? option.textContent || '' : '';
            if (option && option.value) {
                countrySearchInput.dataset.selectedLabel = option.textContent || '';
                countrySearchInput.dataset.selectedValue = option.value;
                countrySearchInput.setCustomValidity('');
            } else {
                countrySearchInput.removeAttribute('data-selected-label');
                countrySearchInput.removeAttribute('data-selected-value');
            }
        });
        label.htmlFor = countrySearchInput.id;
      }
      wrapper.appendChild(select);
      return wrapper;
    }

    var input = el('input');
    input.type = type === 'email' ? 'email' : type === 'tel' ? 'tel' : 'text';
    input.id = id;
    input.name = field.fieldKey;
    if (field.placeholder) input.placeholder = field.placeholder;
    if (field.defaultValue) input.value = field.defaultValue;
    if (field.isRequired) input.required = true;
    if (field.readOnly) input.readOnly = true;
    wrapper.appendChild(input);
    if (field.fieldKey === 'general-phone') {
      input.type = 'tel';
      input.inputMode = 'tel';
      input.autocomplete = 'tel';
      input.pattern = ' *\\+?(?: *[0-9]){10,15} *';
      input.title = t('form.phone_hint');
      var updatePhoneValidity = function () {
        input.setCustomValidity('');
        if (input.validity.valueMissing || input.validity.patternMismatch) {
          input.setCustomValidity(input.title);
        }
      };
      input.addEventListener('input', updatePhoneValidity);
      input.addEventListener('change', updatePhoneValidity);
      input.addEventListener('invalid', updatePhoneValidity);
      updatePhoneValidity();
      var phoneHint = el('div', 'ndx__helper');
      phoneHint.id = id + '-hint';
      phoneHint.textContent = t('form.phone_hint');
      input.setAttribute('aria-describedby', phoneHint.id);
      wrapper.appendChild(phoneHint);
    }

    if (field.helperHtml) {
      var helper = el('div', 'ndx__helper');
      helper.innerHTML = field.helperHtml;
      wrapper.appendChild(helper);
    }
    return wrapper;
  }

  function renderSlotField(info) {
    var wrapper = el('div', 'ndx__field');
    var label = el('label');
    label.htmlFor = 'ndx-slot';
    label.textContent = info.registrationRole === 'accompanying-person' && info.slots.length === 1 && !info.slots[0].time
      ? t('form.day_label') : t('form.slot_label');
    var star = el('span', 'ndx__required');
    star.textContent = ' *';
    label.appendChild(star);
    wrapper.appendChild(label);

    if (info.slotSelection) {
      var select = el('select');
      select.id = 'ndx-slot';
      select.name = 'slot_variant';
      select.required = true;
      var placeholder = el('option');
      placeholder.value = '';
      placeholder.textContent = t('form.slot_placeholder');
      select.appendChild(placeholder);
      info.slots.forEach(function (slot) {
        var option = el('option');
        option.value = slot.variantId;
        option.textContent = slot.label + (slot.soldOut ? t('form.slot_sold_out_suffix') : '');
        if (slot.soldOut) option.disabled = true;
        select.appendChild(option);
      });
      wrapper.appendChild(select);
      return wrapper;
    }

    // Fixed slot: shown read-only, never selectable.
    var slot = info.slots[0];
    var display = el('input');
    display.type = 'text';
    display.id = 'ndx-slot';
    display.value = slot ? slot.label : '';
    display.readOnly = true;
    display.tabIndex = -1;
    wrapper.appendChild(display);

    var hidden = el('input');
    hidden.type = 'hidden';
    hidden.name = 'slot_variant';
    hidden.value = slot ? slot.variantId : '';
    wrapper.appendChild(hidden);
    return wrapper;
  }

  function initForm(root) {
    var dealer = param('dealer');
    var status = param('status');
    var error = param('error');
    var body = root.querySelector('[data-ndx-body]');

    if (status && t('statuses.' + status)) {
      setNotice(root, t('statuses.' + status), true);
      body.textContent = '';
      return;
    }
    if (error) {
      setNotice(root, t('errors.' + error, t('errors.error')), false);
    }
    if (!dealer) {
      body.textContent = t('form.unavailable');
      return;
    }

    fetchInfo(dealer)
      .then(function (info) {
        body.textContent = '';
        if (!info.form) {
          body.textContent = t('form.unavailable');
          return;
        }

        var title = el('h1', 'ndx__title');
        title.textContent = info.form.title;
        body.appendChild(title);

        if (info.registrationRole === 'accompanying-person') {
          var role = el('p', 'ndx__program');
          role.textContent = t('form.accompanying_person');
          body.appendChild(role);
        }

        var programName = t('form.programs.' + info.program);
        if (programName) {
          var subline = el('p', 'ndx__program');
          subline.textContent = programName;
          body.appendChild(subline);
        }

        if (info.form.introHtml && !info.soldOut) {
          var intro = el('div', 'ndx__intro');
          intro.innerHTML = info.form.introHtml;
          body.appendChild(intro);
        }

        var formMeta = renderMeta(info);
        if (formMeta) body.appendChild(formMeta);

        if (info.soldOut) {
          // Every slot of this dealer is taken, so there is nothing else to choose.
          setNotice(root, t('form.event_sold_out', t('form.sold_out')), false);
          return;
        }

        var form = el('form');
        form.method = 'post';
        form.action = '/apps/check-in/ndx/register';
        form.noValidate = false;

        var dealerInput = el('input');
        dealerInput.type = 'hidden';
        dealerInput.name = 'dealer';
        dealerInput.value = info.dealer.handle;
        form.appendChild(dealerInput);

        ['locale', 'customer_locale'].forEach(function (name) {
          var input = el('input');
          input.type = 'hidden';
          input.name = name;
          input.value = COPY.locale || 'de';
          form.appendChild(input);
        });

        form.appendChild(renderSlotField(info));

        // Abuse protection: a field people never see, and how long the form was
        // open before sending. The server rejects filled traps and instant posts.
        var trap = el('input');
        trap.type = 'text';
        trap.name = 'ndx_hp';
        trap.tabIndex = -1;
        trap.autocomplete = 'off';
        trap.setAttribute('aria-hidden', 'true');
        trap.style.cssText = 'position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden;opacity:0;';
        form.appendChild(trap);
        var formShownAt = Date.now();
        var fillTime = el('input');
        fillTime.type = 'hidden';
        fillTime.name = 'ndx_fill_ms';
        form.appendChild(fillTime);
        form.addEventListener('submit', function () {
          fillTime.value = String(Date.now() - formShownAt);
        });

        // Legal documents are linked in the consent copy. Keep the form's
        // attachments for signing, without duplicating them as filename links.
        info.form.fields.forEach(function (field) {
          var node = renderField(field);
          if (!node) return;
          form.appendChild(node);
        });

        var submit = el('button', 'ndx__submit button button-black');
        submit.type = 'submit';
        submit.textContent = info.form.submitLabel;
        form.appendChild(submit);

        var note = el('div', 'ndx__submit-note');
        [t('form.submit_note'), t('form.submit_note_checkin')].forEach(function (text, index) {
          if (!text) return;
          var line = el('p');
          if (index === 0 && t('form.submit_note_label')) {
            var strong = el('strong');
            strong.textContent = t('form.submit_note_label') + ' ';
            line.appendChild(strong);
          }
          line.appendChild(document.createTextNode(text));
          note.appendChild(line);
        });
        if (note.childNodes.length) form.appendChild(note);

        form.addEventListener('submit', function () {
          submit.disabled = true;
          submit.textContent = t('form.submitting');
        });

        body.appendChild(form);
      })
      .catch(function () {
        body.textContent = t('form.unavailable');
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ndx-landing]').forEach(initLanding);
    document.querySelectorAll('[data-ndx-form]').forEach(initForm);
  });
})();
